import { Stat } from '@apps/admin/routes/DashboardPreview/components/DashboardChecklist/components/DashboardStats';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

export const telemetryObject = createTelemetryObject({
  actions: {
    dashboardV3DataLoaded: () => ({
      action: 'DashboardV3DataLoaded',
      category: 'AdminDashboardV3'
    }),
    clickHeaderLink: (link: 'preview' | 'share' | 'support') => ({
      action: 'HeaderLinkInteracted',
      category: 'AdminDashboardV3',
      extraInfo: {
        link
      }
    }),
    clickWebsitePreview: () => ({
      action: 'WebsitePreviewInteracted',
      category: 'AdminDashboardV3'
    }),
    clickWebsiteDesign: () => ({
      action: 'WebsiteDesignInteracted',
      category: 'AdminDashboardV3'
    }),
    clickEventDetails: (type: 'date' | 'location') => ({
      action: 'EventDetailsInteracted',
      category: 'AdminDashboardV3',
      extraInfo: {
        type
      }
    }),
    clickWebsiteStats: (stat: Stat['id']) => ({
      action: 'OpenPageClicked',
      category: 'AdminDashboardV3',
      extraInfo: {
        stat
      }
    })
  }
});

export const { useTelemetry: useDashboardContentV3Telemetry } = createTelemetry(telemetryObject);
